import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface Paging {
  page: number;
  perPage: number;
  pageCount: number;
  totalCount: number;
}

export interface FacultyMember {
  id: number;
  irbApplicationId: number;
  piEmail: string;
  piFirstname: string;
  piLastName: string;
  sponsorEmail: string;
  sponsorDegree: string;
  fullname: string;
  reseachDescription: string;
  irbTitle: string;
  typeOfReview: string;
  signature: string;
  isApproved: boolean;
  requestedDate: Date;
  decisionDate: Date;
  userRole: string;
}

export interface MemberResponse {
  status: string;
  message: string;
  data: Array<FacultyMember>;
}

export interface MemberInfo {
  facultyRequests: MemberResponse;
  message: string;
}

@Module
export default class MemberModule extends VuexModule implements MemberInfo {
  facultyRequests = {} as MemberResponse;
  facultyRequestEdit = {} as FacultyMember;
  message = "";

  get currentFacultyMemberRequests(): MemberResponse {
    return this.facultyRequests;
  }

  get getFacultyMemberMessage(): string {
    return this.message;
  }

  get currentFacultyMemberRequestEdit(): FacultyMember {
    return this.facultyRequestEdit;
  }

  @Mutation
  [Mutations.SET_FACULTY_MEMBER_REQUESTS](facultyRequests) {
    this.facultyRequests = facultyRequests;
  }

  @Mutation
  [Mutations.SET_FACULTY_MEMBER_REQUEST_EDIT](facultyRequestEdit) {
    this.facultyRequestEdit = facultyRequestEdit;
  }

  @Mutation
  [Mutations.SET_FACULTY_MEMBER_MESSAGE](message) {
    this.message = message;
  }

  @Action
  [Actions.GET_FACULTY_MEMBER_REQUESTS]() {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      ApiService.get("irb/irbmember/standard")
        .then(({ data }) => {
          this.context.commit(Mutations.SET_FACULTY_MEMBER_REQUESTS, data);
        })
        .catch(() => {
          this.context.commit(Mutations.SET_FACULTY_MEMBER_REQUESTS, {});
        });
    } else {
      this.context.commit(Mutations.SET_FACULTY_MEMBER_REQUESTS, {});
    }
  }

  @Action
  [Actions.POST_FACULTY_MEMBER_APPROVAL](data) {
      return new Promise<void>((resolve, reject) => {
        this.context.commit(Mutations.SET_IRB_ERROR, "");
        if (JwtService.getToken()) {
          ApiService.setHeader();
          ApiService.post("irbmember/standard/vote", data)
            .then(({ data }) => {
              this.context.commit(Mutations.SET_IRB_ERROR, data.message);
              resolve();
            })
            .catch(({ response }) => {
              this.context.commit(Mutations.SET_IRB_ERROR, response.data.message);
              reject();
            });
        } else {
          this.context.commit(Mutations.SET_IRB_ERROR, "");
          reject();
        }
      });
  }
}
